import React from 'react';

import RouteSkeleton from 'Components/Progress/RouteSkeleton';
import serverSkeleton from 'Components/Progress/serverSkeleton';

// If there is skeleton content in the dom already (from server.js, with slots filled by the cloudflare worker),
// grab/cache that and return it instead of re-rendering the skeleton, to stop good content (usually LCP)
// disappearing then re-appearing. Later navigations render the target page's skeleton.

export default function SkeletonPlaceholder() {
  const placeholderElement = document.querySelector('.content.body-placeholder');
  const contentElement = document.querySelector('.content');
  const skeleton = serverSkeleton();

  // Only return the skeleton html if it's still needed
  if (
    skeleton &&
    window.location.pathname === skeleton.path && (
      (placeholderElement && placeholderElement.innerHTML) ||
      (contentElement && (
        contentElement.innerHTML.length === 0 ||
        contentElement.innerHTML.includes('skeleton-placeholder')
      ))
    )
  ) {
    return <div className="skeleton-placeholder" dangerouslySetInnerHTML={{ __html: skeleton.html }} />; // eslint-disable-line
  }

  return <RouteSkeleton />;
}
